import React from 'react';
import { View } from '@bubble-ui/primitive-view';
import { useDesignContext } from '@klarna/designtokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { defaultComponentTokens } from './defaultComponentTokens';
var SpacerHorizontal = _ref => {
  var {
    spaceToken,
    visible
  } = _ref;
  var designContext = useDesignContext(defaultComponentTokens);
  var sizeValue = designContext.get(spaceToken).value();
  var {
    rootStyle
  } = getDefaultStyleSheet({
    designContext,
    sizeValue,
    visible
  });
  return /*#__PURE__*/React.createElement(View, {
    style: rootStyle
  });
};
SpacerHorizontal.displayName = 'SpacerHorizontal';
export { SpacerHorizontal };
//# sourceMappingURL=index.js.map